import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import { ImUsers, ImUserPlus } from "react-icons/im";
import AccountsCreateForm from "pages/accounts/AccountsCreateForm";
import ProfileView from "pages/accounts/ProfileView";
import { useDispatch } from "react-redux";
import { createDistributorThunk } from "store/reducers/accounts";

function DistributorAccount() {
  const dispatch = useDispatch();
  const formCallback = (input) => {
    console.log(input);
    dispatch(createDistributorThunk(input));
  };
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Distributor"
        viewIcon={<ImUsers />}
        createIcon={<ImUserPlus />}
        createChildren={
          <AccountsCreateForm mod="Distributor" callback={formCallback} />
        }
        listChildren={<ProfileView mod="distributor" />}
      />
    </Box>
  );
}

export default DistributorAccount;
